export default {
  // general
  all_clients: "All clients",
  associated_companies: "Connected Companies",
  select_company: "Select company",
  company: "Company",
  company_name: "Company name",
  company_type: "Type",

  // search
  search_company: "Search company by name, city or country",
  no_company_found: "No company found",

  // actions
  create_company: "Create new company",
  enable_passports: "Enable Passports for company",

  // messages
  company_deleted_successfully: "Company deleted successfully"
};
